import React from 'react';
import {Nav} from 'react-bootstrap';
import {IOptionType} from "../../types/common";
import "./NavigationTabs.scss";

interface INavigationTabsProps {
    extractedTypeOptions: IOptionType[];
    selectedExtractedType: IOptionType;
    setSelectedExtractedType: (extractedType: IOptionType) => void;
}

export const NavigationTabs: React.FC<INavigationTabsProps> = ({
                                                                   selectedExtractedType,
                                                                   setSelectedExtractedType,
                                                                   extractedTypeOptions
                                                               }) => {
    const handleChangeExtractedType = (value: string | null) => {
        if (!value) return;
        const newExtractedType = extractedTypeOptions.find((option) => option.value === value);
        setSelectedExtractedType(newExtractedType ?? extractedTypeOptions[0]);
    };

    return (
        <Nav className="navbar-custom" variant="underline" activeKey={selectedExtractedType.value}
             onSelect={(e) => handleChangeExtractedType(e)}>
            {extractedTypeOptions.map((option: IOptionType) => (
                <Nav.Item key={option.value}>
                    <Nav.Link eventKey={option.value}>{option.label}</Nav.Link>
                </Nav.Item>
            ))}
        </Nav>
    );
};
